@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.EggyScore {
  @extend %font-family-primary;

  border: 1px solid $color-primary-purple;
  border-radius: 1rem;
  position: absolute;
  top: 1em;
  padding-top: 0.5em;
  color: $color-primary-purple;
  font-weight: bold;
  background: $color-white;
  text-align: center;

  .header {
    @extend %font-family-primary;

    position: absolute;
    top: -1em;
    left: 3.5em;
    text-align: center;
    background: $color-white;
    width: 90px;
    float: right;
    font-size: 0.9em;
  }

  .eggySpaces {
    padding: 0.25em;
  }

  .wrapperStyle {
    display: inline-block;
    position: relative;
  }

  .lighterHalf {
    display: inline-block;
    opacity: 0.25;
  }

  .darkerHalf {
    position: absolute;
    top: 0;
    left: 0;
    width: 50%;
    overflow: hidden;
    height: 100%;
  }
}
